import {FC, useCallback} from "react";
import Box from "@mui/material/Box";
import {useRouter} from "../hooks/useRouter.ts";
import {styled} from "@mui/material/styles";
import ProfilePicture from "./ProfilePicture.tsx";
import {PROFILE_PICTURE_PLACEHOLDER} from "../constants/profile.ts";

export type ProfileListItemProps = {
    id: string
    profilePicture?: string
    name: string
}

const StyledBox = styled(Box)(({theme}) =>({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 30,
    background: theme.palette.secondary.main,
    padding: 10,
    marginBottom: 10,
    borderRadius: 10,
    border: '2px solid transparent',
    transition: 'border 0.5s, background-color 0.5s',

    ':hover': {
        backgroundColor: theme.palette.secondary.light,
        border: `2px solid ${theme.palette.secondary.main}`,
    },
}))

const ProfileListItem: FC<ProfileListItemProps> = ({id, profilePicture, name}) => {
    const {gotoMemorial} = useRouter()
    const handleClick = useCallback(() => gotoMemorial(id), [gotoMemorial, id])

    return (
        <StyledBox onClick={handleClick}>
            <ProfilePicture profileID={id} size={80} src={profilePicture || PROFILE_PICTURE_PLACEHOLDER}/>
            <h2>
                {name}
            </h2>
        </StyledBox>
    )
}

export default ProfileListItem
